/**
 * @file apps/web/src/main.tsx
 * @description React 18 application entry point.
 * Wraps the app in BrowserRouter, AuthProvider (SI firm), and PortalAuthProvider (client portal).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AuthProvider } from './lib/auth.js';
import { PortalAuthProvider } from './lib/portalAuth.js';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <PortalAuthProvider>
          <App />
        </PortalAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
